import { ChevronDown } from 'lucide-react';
import { inputClassName } from './input.jsx';
import { cn } from '../lib/utils.js';

/**
 * Native, styled <select> – accessible and keyboard friendly out of the box (also on mobile).
 * @param {import('react').ComponentProps<'select'> & { size?: 'default'|'sm', wrapperClassName?: string }} props
 */
export function Select({ className, wrapperClassName, size = 'default', children, ...props }) {
  return (
    <div data-slot="select-wrapper" className={cn('relative', wrapperClassName)}>
      <select
        data-slot="select"
        className={cn(inputClassName, 'appearance-none pr-8', size === 'sm' && 'h-(--control-height-sm) text-[13px] md:text-[13px]', className)}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" aria-hidden="true" />
    </div>
  );
}
